import { useLazyQuery }        from '@apollo/client'
import { useEffect, useState } from 'react'
import { useSelector }         from 'react-redux'
import { useParams }           from 'react-router-dom'
import { LoadingEllipsis }     from '../../components/Loaders'
import LocationEditForm        from '../../components/Locations/LocationEditForm'
import { GET_LOCATION_BY_ID }  from '../../graphql/location'
import MainLayout              from '../../layouts/MainLayout'

export default function LocationsEdit(): JSX.Element {
  const { location_id }           = useParams()
  const currentUser: any          = useSelector( ( state: any ): any => state.currentUser.user )
  const [ location, setLocation ] = useState( null )

  const [ getLocationById, { loading } ] = useLazyQuery( GET_LOCATION_BY_ID, {
    fetchPolicy: 'network-only',
    onCompleted: ( { locationById }: any ): void => setLocation( locationById ),
    onError:     ( error: any ): void => console.log( error )
  } )

  useEffect( (): any => {
    let shouldFetch: boolean = true

    if ( shouldFetch && location_id ) {
      getLocationById( { variables: { input: { id: location_id } } } )
    }

    return (): void => {
      shouldFetch = false
    }
  }, [ location_id ] )

  return (
    <MainLayout>
      <div className="max-w-screen-3xl mx-auto w-full">
        <div className="flex-grow lg:p-8 p-3 space-y-4 lg:space-y-8">
          { loading && <LoadingEllipsis klass="ellipse-yellow ellipse-xl p-4 mt-4 w-full" /> }

          { !loading && currentUser?.admin && location && <LocationEditForm location={ location } /> }

          { !loading && !currentUser?.admin &&
            <div className="row flex flex-col items-center w-full bg-white rounded-3xl p-3 xl:p-4">
              Access Denied!
            </div>
          }
        </div>
      </div>
    </MainLayout>
  )
}
